import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import EventsListing from '../../vue-components/EventsListing.vue';
import EventDetails from '../../vue-components/EventDetails.vue';
import EventListItem from '../../vue-components/EventListItem';

Vue.component('event-list-item', EventListItem);

const eventsPath = "/pages/events-custom-code";

// let's build a tiny vue app for the custom events page
const eventRouter = new VueRouter({
    base: eventsPath,
    mode: "hash",
    routes: [
        {
            path: "/",
            component: EventsListing,
            name: "eventListing"
        },
        {
            path: "/details/:slug",
            component: EventDetails,
            name: "eventDetails"
        }
    ]
});

const eventsApp = new Vue({
    el: "#events-app-mount",
    data: {
        events: window.snowPeakEvents,
    },
    router: eventRouter
});
